import { LoaderFunctionArgs, redirect } from 'react-router';
import UserDetailsPage from './components/user-management/user-details/user-details-page';
import UserManagement from './components/user-management/user-management';
import GroupDetailsPage from './components/directory/group-details/group-details-view';
import ContactSyncPage from './components/directory/contact-sync/contact-sync-page';
import SharedErrorBoundary from './shared/shared-error-boundary';
import OrgUnitsPage from './components/directory/org-units/org-units-page';
import TransferLogsGridPage from './components/calendars/calendar-transfer-logs/calendar-transfer-logs-grid-page';
import ResourceTemplatesPage from './components/calendars/resource-templates/resource-templates-page';
import ResourceCalendarsDetails from './components/calendars/resource-calendars/resource-calendars-details';
import CalendarsPage from './components/calendars/calendars/calendars-page';
import OwnershipTransferLogsGridPage from './components/drive/ownership-transfer-logs-grid-page';
import DriveSearchPage from './components/drive/drive-search/drive-search-page';
import DriveSweep from './components/drive/drive-sweep/drive-sweep-page';
import CreateDriveSweepFormPage from './components/drive/drive-sweep/create-drive-sweep/create-drive-sweep-form-page';
import DriveExplorerPage from './components/drive/drive-explorer/drive-explorer-page';
import AppLogsPage from './components/logging/logs-page';
import MobileManagementPage from './components/devices/mobile-management/mobile-management-page';
import ChromeDevicesPage from './components/devices/chrome-devices/chrome-devices-page';
import { createBrowserRouter } from 'react-router-dom';
import GroupsPage from './components/directory/groups/groups-page';
import SharedContactsPage from './components/directory/shared-contacts/shared-contacts-page';
import Settings from './components/administration/settings';
import PoliciesPage from './components/policies/policies-page';
import GmailExportPage from './components/import-export/gmail-export/gmail-export-page';
import VaultExportPage from './components/import-export/vault-export/vault-export-page';
import GmailDeletionPage from './components/import-export/gmail-deletion/gmail-deletion-page';
import CpanelLogsPage from './components/report-center/cPanelLogs-page';
import SharedDrivesPage from './components/drive/shared-drives/shared-drives-page';
import ReportsPage from './components/report-center/Reports/reports-page';
import ErrorPage from './shared/error-pages/error-page';
import ExpiredPage from './shared/error-pages/expired-page';
import IpRestrictedPage from './shared/error-pages/ip-restricted-page';
import InvalidDomainPage from './shared/error-pages/invalid-domain-page';
import ErrorMessagePage from './shared/error-pages/error-message-page';
import InvalidAdminPage from './shared/error-pages/invalid-admin-page';
import { pagesConfig } from './shared/pages-config';
import BulkOpsPage from './components/import-export/bulk-operations/bulk-ops-page';
import SignatureTemplatesPage from './components/automation/signature-templates/signature-templates-page';
import ApiPage from './components/administration/api/api-page';
import LabsPage from './components/administration/labs/labs-page';
import RoleManagerPage from './components/administration/role-manager/role-manager-page';
import LabelManagerPage from './components/administration/label-manager/label-manager-page';
import CreateLabelPage from './components/administration/label-manager/create-label/create-label-page';
import CloneLabelPage from './components/administration/label-manager/create-label/clone-label-page';
import EditLabelPage from './components/administration/label-manager/edit-label/edit-label-page';
import IndexingPage from './components/administration/indexing/indexing-page';
import RoleDetailsPage from './components/administration/role-manager/role-details/role-details-view';
import BillingPage from './components/billing/billing-page';
import DecomPage from './components/automation/decommissioning/decom-page';
import CreateDecomPolicyPage from './components/automation/decommissioning/decom-policy-form/create-decom-policy-page';
import EditDecomPolicyPage from './components/automation/decommissioning/decom-policy-form/edit-decom-policy-page';
import CloneDecomPolicyPage from './components/automation/decommissioning/decom-policy-form/clone-decom-policy-page';
import UserGeneralSettings from './components/user-management/user-details/user-general-settings';
import UserAliasesPage from './components/user-management/user-details/aliases/user-aliases-page';
import PersonalContactsPage from './components/user-management/user-details/personal-contacts/personal-contacts-page';
import ProfileInfoPage from './components/user-management/user-details/profile-information/profile-info-page';
import CustomSchemasPage from './components/user-management/user-details/custom-schemas/custom-schemas-page';
import UserGroupsPage from './components/user-management/user-details/groups/user-groups-page';
import UserRolesPage from './components/user-management/user-details/roles/user-roles-page';
import CalendarPage from './components/user-management/user-details/calendars/calendar-page';
import MobileDevicePage from './components/user-management/user-details/devices/mobile-device-page';
import AppPasswordsPage from './components/user-management/user-details/app-passwords/app-passwords-grid-page';
import ThirdPartyAppsPage from './components/user-management/user-details/third-party-apps/third-party-apps-grid-page';
import AuditPage from './components/user-management/user-details/auditing/audit-grid-page';
import DrivePage from './components/user-management/user-details/drive/drive-page';
import HistoryGridPage from './components/user-management/user-details/history/history-grid-page';
import GmailSettings from './components/user-management/user-details/gmail-settings/gmail-settings-page';
import AccountDelegation from './components/user-management/user-details/gmail-settings/account-delegation/account-delegation';
import SendAsGridPage from './components/user-management/user-details/gmail-settings/send-as/send-as-grid-page';
import PopSettingsPage from './components/user-management/user-details/gmail-settings/pop-settings-page';
import LabelsPage from './components/user-management/user-details/gmail-settings/labels/labels-page';
import ImapSettingsPage from './components/user-management/user-details/gmail-settings/imap-settings-page';
import VacationResponderPage from './components/user-management/user-details/gmail-settings/vacation-responder/vacation-responder-page';
import ForwardingPage from './components/user-management/user-details/gmail-settings/forwarding-page';
import ForwardAddressPage from './components/user-management/user-details/gmail-settings/forwarding-addresses/forwarding-address-page';
import SignaturesPage from './components/user-management/user-details/gmail-settings/signatures/signatures-page';
import ProtectedRoute from './shared/protected-route';
import GroupGeneralInfo from './components/directory/group-details/group-general-info';
import BusinessGroupSettings from './components/directory/group-details/business-group-settings/business-group-settings';
import GroupMembership from './components/directory/group-details/membership/group-membership';
import GroupAliasesPage from './components/directory/group-details/aliases/group-aliases-page';
import GroupLogsPage from './components/directory/group-details/history/group-logs-page';
import ResourceCalendarsPage from './components/calendars/resource-calendars/resource-calendars-page';
import BuildingsPage from './components/calendars/resource-calendars/buildings/buildings-page';
import FeaturesPage from './components/calendars/resource-calendars/features/features-page';
import DomainDefaultsPage from './components/calendars/resource-calendars/domain-defaults/domain-defaults-page';
import RolesMembershipPage from './components/administration/role-manager/role-details/membership/roles-membership-page';
import RoleDirectorySearchPage from './components/administration/role-manager/role-details/role-directory-search-page';
import RoleLimitedVisibilityPage from './components/administration/role-manager/role-details/role-limited-visibility-page';
import RolePermissionsPage from './components/administration/role-manager/role-details/role-permissions-page';
import RoleSettings from './components/administration/role-manager/role-details/role-settings-page';
import RoleLogsPage from './components/administration/role-manager/role-details/role-logs-grid-page';
import GoogleAPIStatus from './components/administration/settings/google-api-status';
import IpIntrusionPage from './components/administration/settings/ip-intrusion/ip-intrusion-page';
import SetCustomLabel from './components/administration/settings/set-custom-label';
import SetGpanelAdmin from './components/administration/settings/set-gpanel-admin';
import SetSessionTimeout from './components/administration/settings/set-session-timeout';
import SetTimezone from './components/administration/settings/set-timezone';
import IntegrationsPage from './components/administration/settings/integrations/integrations-page';
import ManageSlackChannelsPage from './components/administration/settings/integrations/manage-slack-channels/manage-slack-channels-page';
import WelcomeTemplatesPage from './components/administration/settings/welcome-templates/welcome-templates-page';
import WelcomeTemplatesFormPage from './components/administration/settings/welcome-templates/welcome-templates-form-page';
import BillingContactsPage from './components/billing/payment-contacts/billing-contacts-page';
import PaymentMethodsPage from './components/billing/payment-methods/payment-methods-page';
import SubscriptionsPage from './components/billing/subscriptions-page';
import LoginPage from './components/login/login-page';
import { canAccessViewQuery, checkAuthQuery } from './api/users-api';
import App from './App';
import AdminLayoutPage from './components/navbar/admin-layout-page';
import RoutesLayout from './routes-layout';
import { auth } from './shared/firebase/firebase-config';
import NotFoundPage from './shared/not-found-page';
import UserPortalPage from './components/user-portal/user-portal-page';
import { userPortalPagesConfig } from './shared/user-portal-pages-config';
import AllGroupsPage from './components/user-portal/all-groups-page';
import CustomAttributesPage from './components/user-portal/custom-attributes-page';
import UserContactsPage from './components/user-portal/user-contacts-page';
import MyGroupsPage from './components/user-portal/my-groups-page';
import DirectorySearchPage from './components/user-portal/directory-search-page';
import TrialPage from './shared/error-pages/trial-page';
import MarketingManagerGridPage from './components/view-admin/marketing-manager-grid-page';
import RouterErrorBoundary from './shared/router-error-boundary';
import SharedContactsUserPortalPage from './components/user-portal/shared-contacts-user-portal-page';
import GmailFiltersPage from './components/user-management/user-details/gmail-settings/filters/gmail-filters-page';
import GpanelContactsRoutes from './components/directory/gpanel-contacts-v2/gpanel-contacts-routes';
import ViewAdminLayout from './components/view-admin/view-admin-layout';
import ErrorTestingPage from './components/view-admin/error-testing-page';
import GroupSecuritySettings from './components/directory/group-details/group-security-settings';
import CommandDashboardPage from './components/command-dashboard/command-dashboard-page';
import RoutesRedirect from './components/navbar/routes-redirect';
import GmailDeletionFormPage from './components/import-export/gmail-deletion/gmail-deletion-form-page';
import ResourceTemplatesFormPage from './components/calendars/resource-templates/resource-templates-form-page';
import ResourceCalendarsFormPage from './components/calendars/resource-calendars/resource-calendars-form-page';

import { QueryClient } from '@tanstack/react-query';
import AdminLabsGridPage from './components/view-admin/admin-labs-grid-page';
import UiSandboxPage from './components/view-admin/ui-sandbox-page';
import SignatureTemplatesFormPage from './components/automation/signature-templates/signature-templates-form-page';
import DecomLogTab from './components/automation/decommissioning/decom-logs/decom-log-tab';
import ReportsFormPage from './components/report-center/Reports/reports-form-page';
import CreateUserFormPage from './components/user-management/add-user-dialog/create-user-form-page';
import InvalidSecondaryDomainPage from './shared/error-pages/invalid-secondary-domain-page';
import AddLicenseForm from './components/billing/add-license-form';
import BulkOpFormPage from './components/import-export/bulk-operations/create-bulk-operation/create-bulk-op-dialog';
import PolicyFormPage from './components/policies/policy-dialog';
import GroupTemplatesPage from './components/directory/group-templates/group-templates-page';
import CreateGroupTemplatePage from './components/directory/group-templates/create-template/create-group-template-page';
import EditGroupTemplatePage from './components/directory/group-templates/edit-template/edit-group-template-page';
import DecomPoliciesPage from './components/automation/decommissioning/decom-policies-page';
import SuspendedUsersPage from './components/automation/decommissioning/decom-suspended-users/suspended-users-page';
import RulesEnginePage from './components/tools/rules-engine/rules-engine-page';
import RulesEngineBrowseTemplatesPage from './components/tools/rules-engine/rules-engine-browse-templates-page';
import CalendarsIndexingPage from './components/administration/indexing/calendars-indexing-page';
import OrgsIndexingPage from './components/administration/indexing/orgs-indexing-page';
import GroupsIndexingPage from './components/administration/indexing/group-indexing-page';
import UsersIndexingPage from './components/administration/indexing/users-indexing-page';
import SecondaryDomainsPage from './components/administration/settings/secondary-domains/secondary-domains-page';
import CreateRulePage from './components/tools/rules-engine/create-rule-page';
import CloneRulePage from './components/tools/rules-engine/clone-rule-page';
import EditRulePage from './components/tools/rules-engine/edit-rule-page';
import InsightsCloudInsightsPage from './components/insights/insights-cloud-insights-page';
import InsightsDetailViewsPage from './components/insights/insights-detail-views-page';
import InsightsHelpfulInformationPage from './components/insights/insights-helpful-information-page';
import AssetDiscoveryPage from './components/insights/cloud-insights/asset-discovery-page';
import DailyTrendsPage from './components/insights/cloud-insights/daily-trends-page';
import RecommendationsPage from './components/insights/cloud-insights/recommendations-page';
import FinOpsPage from './components/insights/cloud-insights/fin-ops-page';
import AgentCostPage from './components/insights/cloud-insights/agent-cost-page';
import AgentOpsPage from './components/insights/cloud-insights/agent-ops-page';
import UserUsagePage from './components/insights/cloud-insights/user-usage-page';
import IamMemberSummaryPage from './components/insights/detail-views/iam-member-summary-page';
import ProjectMemberRolesPage from './components/insights/detail-views/project-member-roles-page';
import InsightsReleaseNotesPage from './components/insights/helpful-information/insights-release-notes-page';
import InsightsPage from './components/insights/insights-page';

function rootLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  if (url.hostname === 'promevo-gpanelds.appspot.com') {
    const newUrl = new URL(
      window.location.pathname + window.location.search,
      'https://gpanel.promevo.com'
    );
    window.location.replace(newUrl.toString());
    return newUrl;
  }
  return url;
}

async function authLoader(
  { request }: LoaderFunctionArgs,
  queryClient: QueryClient
) {
  const params = new URLSearchParams();

  if (new URL(request.url).pathname !== '/') {
    params.set('from', new URL(request.url).pathname);
  }

  await auth.authStateReady();
  try {
    // server check happens first, firebase persistence is 'local' so new window would pass through idToken and create new session
    // firebase needs to be 'local' because opening a new tab for user portal wouldn't have auth.currentUser for 'session'
    const authStatus = await queryClient.ensureQueryData(checkAuthQuery());
    if (authStatus.result === 'SUCCESS') {
      const user = auth.currentUser;
      if (!user) {
        return redirect('/login?' + params.toString());
      }

      return null;
    }
  } catch {
    return redirect('/login?' + params.toString());
  }

  return null;
}

async function loginLoader(
  { request }: LoaderFunctionArgs,
  queryClient: QueryClient
) {
  const url = new URL(request.url);
  const skipAuthCheck = url.searchParams.has('session-timeout');
  if (skipAuthCheck) {
    return null;
  }

  await auth.authStateReady();
  try {
    // don't recall checkAuthQuery if it's already in error state from authLoader
    const state = queryClient.getQueryState(checkAuthQuery().queryKey);
    if (state?.status === 'error') {
      return null;
    }

    const authStatus = await queryClient.ensureQueryData(checkAuthQuery());
    if (authStatus.result === 'SUCCESS') {
      const user = auth.currentUser;
      if (!user) {
        return null;
      }

      return redirect('/');
    }
  } catch {
    return null;
  }

  return null;
}

async function viewAdminLoader(queryClient: QueryClient) {
  await auth.authStateReady();

  try {
    const authStatus = await queryClient.ensureQueryData(checkAuthQuery());

    if (authStatus.result === 'SUCCESS') {
      const user = auth.currentUser;
      if (!user) {
        return redirect('/login');
      }
    }
  } catch {
    return redirect('/login');
  }

  const res = await queryClient.ensureQueryData(
    canAccessViewQuery(auth.currentUser?.email?.split('@')[1] ?? '')
  );

  if (!res) {
    return redirect('/');
  }

  return null;
}

export function createRouter(queryClient: QueryClient) {
  return createBrowserRouter([
    {
      path: '/',
      element: <App />,
      loader: rootLoader,
      id: 'root',
      children: [
        {
          path: '/login',
          element: <LoginPage />,
          loader: (args) => loginLoader(args, queryClient),
          errorElement: <RouterErrorBoundary />,
        },
        {
          path: '/error',
          element: (
            <SharedErrorBoundary section="Error Page">
              <ErrorPage />
            </SharedErrorBoundary>
          ),
        },
        {
          path: '/expired',
          element: (
            <SharedErrorBoundary section="Error Expired Page">
              <ExpiredPage />
            </SharedErrorBoundary>
          ),
        },
        {
          path: '/ip-restricted',
          element: (
            <SharedErrorBoundary section="Error IP Restricted Page">
              <IpRestrictedPage />
            </SharedErrorBoundary>
          ),
        },
        {
          path: '/invalid-domain',
          element: (
            <SharedErrorBoundary section="Error Invalid Domain Page">
              <InvalidDomainPage />
            </SharedErrorBoundary>
          ),
        },
        {
          path: '/error-message',
          element: (
            <SharedErrorBoundary section="Error Message Page">
              <ErrorMessagePage />
            </SharedErrorBoundary>
          ),
        },
        {
          path: '/invalid-admin',
          element: (
            <SharedErrorBoundary section="Error Invalid Admin Page">
              <InvalidAdminPage />
            </SharedErrorBoundary>
          ),
        },
        {
          path: '/trial',
          element: (
            <SharedErrorBoundary section="Error Trial Page">
              <TrialPage />
            </SharedErrorBoundary>
          ),
        },
        {
          path: '/invalid-secondary-domain',
          element: (
            <SharedErrorBoundary section="Error Invalid Secondary Domain Page">
              <InvalidSecondaryDomainPage />
            </SharedErrorBoundary>
          ),
        },
        {
          element: <RoutesLayout />,
          loader: (args) => authLoader(args, queryClient),
          shouldRevalidate: () => false,
          errorElement: <RouterErrorBoundary />,
          children: [
            {
              path: '/',
              element: <AdminLayoutPage />,
              children: [
                {
                  index: true,
                  element: <RoutesRedirect />,
                },
                {
                  path: pagesConfig.commandDashboard.link,
                  element: (
                    <ProtectedRoute
                      component={CommandDashboardPage}
                      pageConfigItem={pagesConfig.commandDashboard}
                    />
                  ),
                },
                {
                  path: pagesConfig.viewAdmin.link,
                  element: (
                    <ProtectedRoute
                      component={ViewAdminLayout}
                      pageConfigItem={pagesConfig.viewAdmin}
                    />
                  ),
                  loader: () => viewAdminLoader(queryClient),
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={MarketingManagerGridPage}
                          pageConfigItem={pagesConfig.marketingManager}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.marketingManager.link,
                      element: (
                        <ProtectedRoute
                          component={MarketingManagerGridPage}
                          pageConfigItem={pagesConfig.marketingManager}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.errorTesting.link,
                      element: (
                        <ProtectedRoute
                          component={ErrorTestingPage}
                          pageConfigItem={pagesConfig.errorTesting}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.adminLabs.link,
                      element: (
                        <ProtectedRoute
                          component={AdminLabsGridPage}
                          pageConfigItem={pagesConfig.adminLabs}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.uiSandbox.link,
                      element: (
                        <ProtectedRoute
                          component={UiSandboxPage}
                          pageConfigItem={pagesConfig.uiSandbox}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.users.link,
                  element: (
                    <ProtectedRoute
                      component={UserManagement}
                      pageConfigItem={pagesConfig.users}
                    />
                  ),
                  children: [
                    {
                      path: pagesConfig.createUser.link,
                      element: (
                        <ProtectedRoute
                          component={CreateUserFormPage}
                          pageConfigItem={pagesConfig.createUser}
                        />
                      ),
                    },
                    {
                      path: `${pagesConfig.userDetails.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={UserDetailsPage}
                          pageConfigItem={pagesConfig.userDetails}
                        />
                      ),
                      children: [
                        {
                          index: true,
                          element: (
                            <ProtectedRoute
                              component={UserGeneralSettings}
                              pageConfigItem={pagesConfig.generalSettings}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.generalSettings.link,
                          element: (
                            <ProtectedRoute
                              component={UserGeneralSettings}
                              pageConfigItem={pagesConfig.generalSettings}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.userDetailsRoles.link,
                          element: (
                            <ProtectedRoute
                              component={UserRolesPage}
                              pageConfigItem={pagesConfig.userDetailsRoles}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.aliases.link,
                          element: (
                            <ProtectedRoute
                              component={UserAliasesPage}
                              pageConfigItem={pagesConfig.aliases}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.personalContacts.link,
                          element: (
                            <ProtectedRoute
                              component={PersonalContactsPage}
                              pageConfigItem={pagesConfig.personalContacts}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.profileInformation.link,
                          element: (
                            <ProtectedRoute
                              component={ProfileInfoPage}
                              pageConfigItem={pagesConfig.profileInformation}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.customAttributes.link,
                          element: (
                            <ProtectedRoute
                              component={CustomSchemasPage}
                              pageConfigItem={pagesConfig.customAttributes}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.userDetailsGroups.link,
                          element: (
                            <ProtectedRoute
                              component={UserGroupsPage}
                              pageConfigItem={pagesConfig.userDetailsGroups}
                            />
                          ),
                        },
                        {
                          path: `${pagesConfig.gmailSettings.link}/*`,
                          element: (
                            <ProtectedRoute
                              component={GmailSettings}
                              pageConfigItem={pagesConfig.gmailSettings}
                            />
                          ),
                          children: [
                            {
                              index: true,
                              element: (
                                <ProtectedRoute
                                  component={AccountDelegation}
                                  pageConfigItem={pagesConfig.accountDelegation}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.accountDelegation.link,
                              element: (
                                <ProtectedRoute
                                  component={AccountDelegation}
                                  pageConfigItem={pagesConfig.accountDelegation}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.filters.link,
                              element: (
                                <ProtectedRoute
                                  component={GmailFiltersPage}
                                  pageConfigItem={pagesConfig.filters}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.sendAs.link,
                              element: (
                                <ProtectedRoute
                                  component={SendAsGridPage}
                                  pageConfigItem={pagesConfig.sendAs}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.labels.link,
                              element: (
                                <ProtectedRoute
                                  component={LabelsPage}
                                  pageConfigItem={pagesConfig.labels}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.popSettings.link,
                              element: (
                                <ProtectedRoute
                                  component={PopSettingsPage}
                                  pageConfigItem={pagesConfig.popSettings}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.imapSettings.link,
                              element: (
                                <ProtectedRoute
                                  component={ImapSettingsPage}
                                  pageConfigItem={pagesConfig.imapSettings}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.vacationResponder.link,
                              element: (
                                <ProtectedRoute
                                  component={VacationResponderPage}
                                  pageConfigItem={pagesConfig.vacationResponder}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.forwarding.link,
                              element: (
                                <ProtectedRoute
                                  component={ForwardingPage}
                                  pageConfigItem={pagesConfig.forwarding}
                                />
                              ),
                            },
                            {
                              path: pagesConfig.forwardingAddresses.link,
                              element: (
                                <ProtectedRoute
                                  component={ForwardAddressPage}
                                  pageConfigItem={
                                    pagesConfig.forwardingAddresses
                                  }
                                />
                              ),
                            },
                            {
                              path: pagesConfig.signatures.link,
                              element: (
                                <ProtectedRoute
                                  component={SignaturesPage}
                                  pageConfigItem={pagesConfig.signatures}
                                />
                              ),
                            },
                          ],
                        },
                        {
                          path: pagesConfig.userDetailsCalendars.link,
                          element: (
                            <ProtectedRoute
                              component={CalendarPage}
                              pageConfigItem={pagesConfig.userDetailsCalendars}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.userDetailsMobileDevices.link,
                          element: (
                            <ProtectedRoute
                              component={MobileDevicePage}
                              pageConfigItem={
                                pagesConfig.userDetailsMobileDevices
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.appPasswords.link,
                          element: (
                            <ProtectedRoute
                              component={AppPasswordsPage}
                              pageConfigItem={pagesConfig.appPasswords}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.thirdPartyApps.link,
                          element: (
                            <ProtectedRoute
                              component={ThirdPartyAppsPage}
                              pageConfigItem={pagesConfig.thirdPartyApps}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.auditing.link,
                          element: (
                            <ProtectedRoute
                              component={AuditPage}
                              pageConfigItem={pagesConfig.auditing}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.userDetailsDrive.link,
                          element: (
                            <ProtectedRoute
                              component={DrivePage}
                              pageConfigItem={pagesConfig.userDetailsDrive}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.userDriveSearch.link,
                          element: (
                            <ProtectedRoute
                              component={DriveSearchPage}
                              pageConfigItem={pagesConfig.userDriveSearch}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.userDetailsHistory.link,
                          element: (
                            <ProtectedRoute
                              component={HistoryGridPage}
                              pageConfigItem={pagesConfig.userDetailsHistory}
                            />
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: `${pagesConfig.gpanelContacts.link}/*`,
                  element: (
                    <ProtectedRoute
                      component={GpanelContactsRoutes}
                      pageConfigItem={pagesConfig.gpanelContacts}
                    />
                  ),
                },
                {
                  path: pagesConfig.groups.link,
                  element: (
                    <ProtectedRoute
                      component={GroupsPage}
                      pageConfigItem={pagesConfig.groups}
                    />
                  ),
                  children: [
                    {
                      path: `${pagesConfig.groupDetails.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={GroupDetailsPage}
                          pageConfigItem={pagesConfig.groupDetails}
                        />
                      ),
                      children: [
                        {
                          index: true,
                          element: (
                            <ProtectedRoute
                              component={GroupGeneralInfo}
                              pageConfigItem={
                                pagesConfig.groupsGeneralInformation
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.groupsGeneralInformation.link,
                          element: (
                            <ProtectedRoute
                              component={GroupGeneralInfo}
                              pageConfigItem={
                                pagesConfig.groupsGeneralInformation
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.businessGroupSettings.link,
                          element: (
                            <ProtectedRoute
                              component={BusinessGroupSettings}
                              pageConfigItem={pagesConfig.businessGroupSettings}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.groupSecuritySettings.link,
                          element: (
                            <ProtectedRoute
                              component={GroupSecuritySettings}
                              pageConfigItem={pagesConfig.groupSecuritySettings}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.groupMembership.link,
                          element: (
                            <ProtectedRoute
                              component={GroupMembership}
                              pageConfigItem={pagesConfig.groupMembership}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.groupAliases.link,
                          element: (
                            <ProtectedRoute
                              component={GroupAliasesPage}
                              pageConfigItem={pagesConfig.groupAliases}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.groupLogs.link,
                          element: (
                            <ProtectedRoute
                              component={GroupLogsPage}
                              pageConfigItem={pagesConfig.groupLogs}
                            />
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: pagesConfig.groupTemplates.link,
                  element: (
                    <ProtectedRoute
                      component={GroupTemplatesPage}
                      pageConfigItem={pagesConfig.groupTemplates}
                    />
                  ),
                  children: [
                    {
                      path: pagesConfig.createGroupTemplate.link,
                      element: (
                        <ProtectedRoute
                          component={CreateGroupTemplatePage}
                          pageConfigItem={pagesConfig.createGroupTemplate}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editGroupTemplate.link,
                      element: (
                        <ProtectedRoute
                          component={EditGroupTemplatePage}
                          pageConfigItem={pagesConfig.editGroupTemplate}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.orgUnits.link,
                  element: (
                    <ProtectedRoute
                      component={OrgUnitsPage}
                      pageConfigItem={pagesConfig.orgUnits}
                    />
                  ),
                },
                {
                  path: pagesConfig.sharedContacts.link,
                  element: (
                    <ProtectedRoute
                      component={SharedContactsPage}
                      pageConfigItem={pagesConfig.sharedContacts}
                    />
                  ),
                },
                {
                  path: pagesConfig.contactSync.link,
                  element: (
                    <ProtectedRoute
                      component={ContactSyncPage}
                      pageConfigItem={pagesConfig.contactSync}
                    />
                  ),
                },
                {
                  path: pagesConfig.calendars.link,
                  element: (
                    <ProtectedRoute
                      component={CalendarsPage}
                      pageConfigItem={pagesConfig.calendars}
                    />
                  ),
                },
                {
                  path: `${pagesConfig.resourceCalendarsLayout.link}/*`,
                  element: (
                    <ProtectedRoute
                      component={ResourceCalendarsDetails}
                      pageConfigItem={pagesConfig.resourceCalendarsLayout}
                    />
                  ),
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={ResourceCalendarsPage}
                          pageConfigItem={pagesConfig.resourceCalendars}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.createResourceCalendar.link,
                      element: (
                        <ProtectedRoute
                          component={ResourceCalendarsFormPage}
                          pageConfigItem={pagesConfig.createResourceCalendar}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editResourceCalendar.link,
                      element: (
                        <ProtectedRoute
                          component={ResourceCalendarsFormPage}
                          pageConfigItem={pagesConfig.editResourceCalendar}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.resourceCalendars.link,
                      element: (
                        <ProtectedRoute
                          component={ResourceCalendarsPage}
                          pageConfigItem={pagesConfig.resourceCalendars}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.resourceBuildings.link,
                      element: (
                        <ProtectedRoute
                          component={BuildingsPage}
                          pageConfigItem={pagesConfig.resourceBuildings}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.resourceFeatures.link,
                      element: (
                        <ProtectedRoute
                          component={FeaturesPage}
                          pageConfigItem={pagesConfig.resourceFeatures}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.resourceDefaults.link,
                      element: (
                        <ProtectedRoute
                          component={DomainDefaultsPage}
                          pageConfigItem={pagesConfig.resourceDefaults}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.resourceTemplates.link,
                  element: (
                    <ProtectedRoute
                      component={ResourceTemplatesPage}
                      pageConfigItem={pagesConfig.resourceTemplates}
                    />
                  ),

                  children: [
                    {
                      path: pagesConfig.createResourceTemplate.link,
                      element: (
                        <ProtectedRoute
                          component={ResourceTemplatesFormPage}
                          pageConfigItem={pagesConfig.createResourceTemplate}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editResourceTemplate.link,
                      element: (
                        <ProtectedRoute
                          component={ResourceTemplatesFormPage}
                          pageConfigItem={pagesConfig.editResourceTemplate}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.calendarTransferLogs.link,
                  element: (
                    <ProtectedRoute
                      component={TransferLogsGridPage}
                      pageConfigItem={pagesConfig.calendarTransferLogs}
                    />
                  ),
                },
                {
                  path: pagesConfig.driveExplorer.link,
                  element: (
                    <ProtectedRoute
                      component={DriveExplorerPage}
                      pageConfigItem={pagesConfig.driveExplorer}
                    />
                  ),
                },
                {
                  path: pagesConfig.driveSearch.link,
                  element: (
                    <ProtectedRoute
                      component={DriveSearchPage}
                      pageConfigItem={pagesConfig.driveSearch}
                    />
                  ),
                },
                {
                  path: pagesConfig.ownershipTransferLogs.link,
                  element: (
                    <ProtectedRoute
                      component={OwnershipTransferLogsGridPage}
                      pageConfigItem={pagesConfig.ownershipTransferLogs}
                    />
                  ),
                },
                {
                  path: pagesConfig.driveSweep.link,
                  element: (
                    <ProtectedRoute
                      component={DriveSweep}
                      pageConfigItem={pagesConfig.driveSweep}
                    />
                  ),
                  children: [
                    {
                      path: pagesConfig.createDriveSweepFormPage.link,
                      element: (
                        <ProtectedRoute
                          component={CreateDriveSweepFormPage}
                          pageConfigItem={pagesConfig.createDriveSweepFormPage}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.sharedDrives.link,
                  element: (
                    <ProtectedRoute
                      component={SharedDrivesPage}
                      pageConfigItem={pagesConfig.sharedDrives}
                    />
                  ),
                },
                {
                  path: pagesConfig.mobileManagement.link,
                  element: (
                    <ProtectedRoute
                      component={MobileManagementPage}
                      pageConfigItem={pagesConfig.mobileManagement}
                    />
                  ),
                },
                {
                  path: pagesConfig.chromeDevices.link,
                  element: (
                    <ProtectedRoute
                      component={ChromeDevicesPage}
                      pageConfigItem={pagesConfig.chromeDevices}
                    />
                  ),
                },
                {
                  path: pagesConfig.logging.link,
                  element: (
                    <ProtectedRoute
                      component={AppLogsPage}
                      pageConfigItem={pagesConfig.logging}
                    />
                  ),
                },
                {
                  path: pagesConfig.reports.link,
                  element: (
                    <ProtectedRoute
                      component={ReportsPage}
                      pageConfigItem={pagesConfig.reports}
                    />
                  ),

                  children: [
                    {
                      path: pagesConfig.createReport.link,
                      element: (
                        <ProtectedRoute
                          component={ReportsFormPage}
                          pageConfigItem={pagesConfig.createReport}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editReport.link,
                      element: (
                        <ProtectedRoute
                          component={ReportsFormPage}
                          pageConfigItem={pagesConfig.editReport}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.cPanelLogs.link,
                  element: (
                    <ProtectedRoute
                      component={CpanelLogsPage}
                      pageConfigItem={pagesConfig.cPanelLogs}
                    />
                  ),
                },
                {
                  path: pagesConfig.rulesEngine.link,
                  element: (
                    <ProtectedRoute
                      component={RulesEnginePage}
                      pageConfigItem={pagesConfig.rulesEngine}
                    />
                  ),

                  children: [
                    {
                      path: pagesConfig.createRule.link,
                      element: (
                        <ProtectedRoute
                          component={CreateRulePage}
                          pageConfigItem={pagesConfig.createRule}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.browseTemplates.link,
                      element: (
                        <ProtectedRoute
                          component={RulesEngineBrowseTemplatesPage}
                          pageConfigItem={pagesConfig.browseTemplates}
                        />
                      ),
                    },
                    {
                      path: `${pagesConfig.cloneRule.link}/:id`,
                      element: (
                        <ProtectedRoute
                          component={CloneRulePage}
                          pageConfigItem={pagesConfig.cloneRule}
                        />
                      ),
                    },
                    {
                      path: 'edit/:id',
                      element: (
                        <ProtectedRoute
                          component={EditRulePage}
                          pageConfigItem={pagesConfig.editRule}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.policies.link,
                  element: (
                    <ProtectedRoute
                      component={PoliciesPage}
                      pageConfigItem={pagesConfig.policies}
                    />
                  ),
                  children: [
                    {
                      path: pagesConfig.createPolicy.link,
                      element: (
                        <ProtectedRoute
                          component={PolicyFormPage}
                          pageConfigItem={pagesConfig.createPolicy}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editPolicy.link,
                      element: (
                        <ProtectedRoute
                          component={PolicyFormPage}
                          pageConfigItem={pagesConfig.editPolicy}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.clonePolicy.link,
                      element: (
                        <ProtectedRoute
                          component={PolicyFormPage}
                          pageConfigItem={pagesConfig.clonePolicy}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: `${pagesConfig.decommissioningLayout.link}/*`,
                  element: (
                    <ProtectedRoute
                      component={DecomPage}
                      pageConfigItem={pagesConfig.decommissioningLayout}
                    />
                  ),
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={DecomPoliciesPage}
                          pageConfigItem={pagesConfig.decomPolicies}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.decomPolicies.link,
                      element: (
                        <ProtectedRoute
                          component={DecomPoliciesPage}
                          pageConfigItem={pagesConfig.decomPolicies}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.decomSuspendedUsers.link,
                      element: (
                        <ProtectedRoute
                          component={SuspendedUsersPage}
                          pageConfigItem={pagesConfig.decomSuspendedUsers}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.decomLogs.link,
                      element: (
                        <ProtectedRoute
                          component={DecomLogTab}
                          pageConfigItem={pagesConfig.decomLogs}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.createDecomPolicyFormPage.link,
                      element: (
                        <ProtectedRoute
                          component={CreateDecomPolicyPage}
                          pageConfigItem={pagesConfig.createDecomPolicyFormPage}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editDecomPolicyFormPage.link,
                      element: (
                        <ProtectedRoute
                          component={EditDecomPolicyPage}
                          pageConfigItem={pagesConfig.editDecomPolicyFormPage}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.cloneDecomPolicyFormPage.link,
                      element: (
                        <ProtectedRoute
                          component={CloneDecomPolicyPage}
                          pageConfigItem={pagesConfig.cloneDecomPolicyFormPage}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.signatureTemplates.link,
                  element: (
                    <ProtectedRoute
                      component={SignatureTemplatesPage}
                      pageConfigItem={pagesConfig.signatureTemplates}
                    />
                  ),

                  children: [
                    {
                      path: pagesConfig.createSignatureTemplate.link,
                      element: (
                        <ProtectedRoute
                          component={SignatureTemplatesFormPage}
                          pageConfigItem={pagesConfig.createSignatureTemplate}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editSignatureTemplate.link,
                      element: (
                        <ProtectedRoute
                          component={SignatureTemplatesFormPage}
                          pageConfigItem={pagesConfig.editSignatureTemplate}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.cloneSignatureTemplate.link,
                      element: (
                        <ProtectedRoute
                          component={SignatureTemplatesFormPage}
                          pageConfigItem={pagesConfig.cloneSignatureTemplate}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.bulkOps.link,
                  element: (
                    <ProtectedRoute
                      component={BulkOpsPage}
                      pageConfigItem={pagesConfig.bulkOps}
                    />
                  ),
                  children: [
                    {
                      path: pagesConfig.createBulkOps.link,
                      element: (
                        <ProtectedRoute
                          component={BulkOpFormPage}
                          pageConfigItem={pagesConfig.createBulkOps}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.gmailExport.link,
                  element: (
                    <ProtectedRoute
                      component={GmailExportPage}
                      pageConfigItem={pagesConfig.gmailExport}
                    />
                  ),
                },
                {
                  path: pagesConfig.vaultExport.link,
                  element: (
                    <ProtectedRoute
                      component={VaultExportPage}
                      pageConfigItem={pagesConfig.vaultExport}
                    />
                  ),
                },
                {
                  path: pagesConfig.gmailDeletion.link,
                  element: (
                    <ProtectedRoute
                      component={GmailDeletionPage}
                      pageConfigItem={pagesConfig.gmailDeletion}
                    />
                  ),
                  children: [
                    {
                      path: pagesConfig.createGmailDeletionFormPage.link,
                      element: (
                        <ProtectedRoute
                          component={GmailDeletionFormPage}
                          pageConfigItem={
                            pagesConfig.createGmailDeletionFormPage
                          }
                        />
                      ),
                    },
                    {
                      path: pagesConfig.editGmailDeletionFormPage.link,
                      element: (
                        <ProtectedRoute
                          component={GmailDeletionFormPage}
                          pageConfigItem={pagesConfig.editGmailDeletionFormPage}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: `${pagesConfig.indexing.link}/*`,
                  element: (
                    <ProtectedRoute
                      component={IndexingPage}
                      pageConfigItem={pagesConfig.indexing}
                    />
                  ),
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={UsersIndexingPage}
                          pageConfigItem={pagesConfig.indexingUsers}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.indexingUsers.link,
                      element: (
                        <ProtectedRoute
                          component={UsersIndexingPage}
                          pageConfigItem={pagesConfig.indexingUsers}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.indexingGroups.link,
                      element: (
                        <ProtectedRoute
                          component={GroupsIndexingPage}
                          pageConfigItem={pagesConfig.indexingGroups}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.indexingCalendars.link,
                      element: (
                        <ProtectedRoute
                          component={CalendarsIndexingPage}
                          pageConfigItem={pagesConfig.indexingCalendars}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.indexingOrgs.link,
                      element: (
                        <ProtectedRoute
                          component={OrgsIndexingPage}
                          pageConfigItem={pagesConfig.indexingOrgs}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: pagesConfig.labs.link,
                  element: (
                    <ProtectedRoute
                      component={LabsPage}
                      pageConfigItem={pagesConfig.labs}
                    />
                  ),
                },
                {
                  path: pagesConfig.driveLabelsManager.link,
                  element: (
                    <ProtectedRoute
                      component={LabelManagerPage}
                      pageConfigItem={pagesConfig.driveLabelsManager}
                    />
                  ),
                },
                {
                  path: pagesConfig.createDriveLabel.link,
                  element: (
                    <ProtectedRoute
                      component={CreateLabelPage}
                      pageConfigItem={pagesConfig.createDriveLabel}
                    />
                  ),
                },
                {
                  path: pagesConfig.cloneDriveLabel.link,
                  element: (
                    <ProtectedRoute
                      component={CloneLabelPage}
                      pageConfigItem={pagesConfig.cloneDriveLabel}
                    />
                  ),
                },
                {
                  path: pagesConfig.editDriveLabel.link,
                  element: (
                    <ProtectedRoute
                      component={EditLabelPage}
                      pageConfigItem={pagesConfig.editDriveLabel}
                    />
                  ),
                },
                {
                  path: pagesConfig.roleManager.link,
                  element: (
                    <ProtectedRoute
                      component={RoleManagerPage}
                      pageConfigItem={pagesConfig.roleManager}
                    />
                  ),
                  children: [
                    {
                      path: `${pagesConfig.roleManagerDetails.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={RoleDetailsPage}
                          pageConfigItem={pagesConfig.roleManagerDetails}
                        />
                      ),
                      children: [
                        {
                          index: true,
                          element: (
                            <ProtectedRoute
                              component={RolePermissionsPage}
                              pageConfigItem={
                                pagesConfig.roleManagerPermissions
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.roleManagerPermissions.link,
                          element: (
                            <ProtectedRoute
                              component={RolePermissionsPage}
                              pageConfigItem={
                                pagesConfig.roleManagerPermissions
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.roleManagerMembership.link,
                          element: (
                            <ProtectedRoute
                              component={RolesMembershipPage}
                              pageConfigItem={pagesConfig.roleManagerMembership}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.roleManagerSettings.link,
                          element: (
                            <ProtectedRoute
                              component={RoleSettings}
                              pageConfigItem={pagesConfig.roleManagerSettings}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.roleManagerLimitedVisibility.link,
                          element: (
                            <ProtectedRoute
                              component={RoleLimitedVisibilityPage}
                              pageConfigItem={
                                pagesConfig.roleManagerLimitedVisibility
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.roleManagerDirectorySearch.link,
                          element: (
                            <ProtectedRoute
                              component={RoleDirectorySearchPage}
                              pageConfigItem={
                                pagesConfig.roleManagerDirectorySearch
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.roleManagerLogs.link,
                          element: (
                            <ProtectedRoute
                              component={RoleLogsPage}
                              pageConfigItem={pagesConfig.roleManagerLogs}
                            />
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: pagesConfig.api.link,
                  element: (
                    <ProtectedRoute
                      component={ApiPage}
                      pageConfigItem={pagesConfig.api}
                    />
                  ),
                },
                {
                  path: `${pagesConfig.settings.link}/*`,
                  element: (
                    <ProtectedRoute
                      component={Settings}
                      pageConfigItem={pagesConfig.settings}
                    />
                  ),
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={SetGpanelAdmin}
                          pageConfigItem={pagesConfig.setGpanelAdmin}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.setGpanelAdmin.link,
                      element: (
                        <ProtectedRoute
                          component={SetGpanelAdmin}
                          pageConfigItem={pagesConfig.setGpanelAdmin}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.ipIntrusion.link,
                      element: (
                        <ProtectedRoute
                          component={IpIntrusionPage}
                          pageConfigItem={pagesConfig.ipIntrusion}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.secondaryDomains.link,
                      element: (
                        <ProtectedRoute
                          component={SecondaryDomainsPage}
                          pageConfigItem={pagesConfig.secondaryDomains}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.timezone.link,
                      element: (
                        <ProtectedRoute
                          component={SetTimezone}
                          pageConfigItem={pagesConfig.timezone}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.customLabeling.link,
                      element: (
                        <ProtectedRoute
                          component={SetCustomLabel}
                          pageConfigItem={pagesConfig.customLabeling}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.sessionTimeout.link,
                      element: (
                        <ProtectedRoute
                          component={SetSessionTimeout}
                          pageConfigItem={pagesConfig.sessionTimeout}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.googleApiStatus.link,
                      element: (
                        <ProtectedRoute
                          component={GoogleAPIStatus}
                          pageConfigItem={pagesConfig.googleApiStatus}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.welcomeTemplates.link,
                      element: (
                        <ProtectedRoute
                          component={WelcomeTemplatesPage}
                          pageConfigItem={pagesConfig.welcomeTemplates}
                        />
                      ),
                      children: [
                        {
                          path: pagesConfig.welcomeTemplatesFormPage.link,
                          element: (
                            <ProtectedRoute
                              component={WelcomeTemplatesFormPage}
                              pageConfigItem={
                                pagesConfig.welcomeTemplatesFormPage
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.editWelcomeTemplatesFormPage.link,
                          element: (
                            <ProtectedRoute
                              component={WelcomeTemplatesFormPage}
                              pageConfigItem={
                                pagesConfig.editWelcomeTemplatesFormPage
                              }
                            />
                          ),
                        },
                      ],
                    },
                    {
                      path: pagesConfig.integrations.link,
                      children: [
                        {
                          index: true,
                          element: (
                            <ProtectedRoute
                              component={IntegrationsPage}
                              pageConfigItem={pagesConfig.integrations}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.manageSlackChannels.link,
                          element: (
                            <ProtectedRoute
                              component={ManageSlackChannelsPage}
                              pageConfigItem={pagesConfig.manageSlackChannels}
                            />
                          ),
                        },
                      ],
                    },
                  ],
                },

                {
                  path: `${pagesConfig.insights.link}/*`,
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={InsightsPage}
                          pageConfigItem={pagesConfig.insightsCloudInsights}
                        />
                      ),
                    },
                    {
                      path: `${pagesConfig.insightsCloudInsights.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={InsightsCloudInsightsPage}
                          pageConfigItem={pagesConfig.insightsCloudInsights}
                        />
                      ),
                      children: [
                        {
                          path: pagesConfig.insightsAssetDiscovery.link,
                          element: (
                            <ProtectedRoute
                              component={AssetDiscoveryPage}
                              pageConfigItem={
                                pagesConfig.insightsAssetDiscovery
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.insightsRecommendations.link,
                          element: (
                            <ProtectedRoute
                              component={RecommendationsPage}
                              pageConfigItem={
                                pagesConfig.insightsRecommendations
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.insightsDailyTrends.link,
                          element: (
                            <ProtectedRoute
                              component={DailyTrendsPage}
                              pageConfigItem={pagesConfig.insightsDailyTrends}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.insightsFinOps.link,
                          element: (
                            <ProtectedRoute
                              component={FinOpsPage}
                              pageConfigItem={pagesConfig.insightsFinOps}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.insightsAgentCost.link,
                          element: (
                            <ProtectedRoute
                              component={AgentCostPage}
                              pageConfigItem={pagesConfig.insightsAgentCost}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.insightsAgentOps.link,
                          element: (
                            <ProtectedRoute
                              component={AgentOpsPage}
                              pageConfigItem={pagesConfig.insightsAgentOps}
                            />
                          ),
                        },
                        {
                          path: pagesConfig.insightsUserUsage.link,
                          element: (
                            <ProtectedRoute
                              component={UserUsagePage}
                              pageConfigItem={pagesConfig.insightsUserUsage}
                            />
                          ),
                        },
                      ],
                    },
                    {
                      path: `${pagesConfig.insightsDetailViews.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={InsightsDetailViewsPage}
                          pageConfigItem={pagesConfig.insightsDetailViews}
                        />
                      ),
                      children: [
                        {
                          path: pagesConfig.insightsIamMemberSummary.link,
                          element: (
                            <ProtectedRoute
                              component={IamMemberSummaryPage}
                              pageConfigItem={
                                pagesConfig.insightsIamMemberSummary
                              }
                            />
                          ),
                        },
                        {
                          path: pagesConfig.insightsProjectMemberRoles.link,
                          element: (
                            <ProtectedRoute
                              component={ProjectMemberRolesPage}
                              pageConfigItem={
                                pagesConfig.insightsProjectMemberRoles
                              }
                            />
                          ),
                        },
                      ],
                    },
                    {
                      path: `${pagesConfig.insightsHelpfulInformation.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={InsightsHelpfulInformationPage}
                          pageConfigItem={
                            pagesConfig.insightsHelpfulInformation
                          }
                        />
                      ),
                      children: [
                        {
                          path: pagesConfig.insightsReleaseNotes.link,
                          element: (
                            <ProtectedRoute
                              component={InsightsReleaseNotesPage}
                              pageConfigItem={pagesConfig.insightsReleaseNotes}
                            />
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: `${pagesConfig.billing.link}/*`,
                  element: (
                    <ProtectedRoute
                      component={BillingPage}
                      pageConfigItem={pagesConfig.billing}
                    />
                  ),
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={SubscriptionsPage}
                          pageConfigItem={pagesConfig.billingSubscriptions}
                        />
                      ),
                    },
                    {
                      path: `${pagesConfig.billingSubscriptions.link}/:orderNumber?`,
                      element: (
                        <ProtectedRoute
                          component={SubscriptionsPage}
                          pageConfigItem={pagesConfig.billingSubscriptions}
                        />
                      ),
                      children: [
                        {
                          path: pagesConfig.addLicense.link,
                          element: (
                            <ProtectedRoute
                              component={AddLicenseForm}
                              pageConfigItem={pagesConfig.addLicense}
                            />
                          ),
                        },
                      ],
                    },
                    {
                      path: pagesConfig.billingPayments.link,
                      element: (
                        <ProtectedRoute
                          component={PaymentMethodsPage}
                          pageConfigItem={pagesConfig.billingPayments}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.billingContacts.link,
                      element: (
                        <ProtectedRoute
                          component={BillingContactsPage}
                          pageConfigItem={pagesConfig.billingContacts}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: '*',
                  element: <NotFoundPage />,
                },
              ],
            },
            {
              path: `${userPortalPagesConfig.userPortal.link}/*`,
              element: (
                <ProtectedRoute
                  component={UserPortalPage}
                  pageConfigItem={userPortalPagesConfig.userPortal}
                />
              ),
              children: [
                {
                  index: true,
                  element: (
                    <ProtectedRoute
                      component={ProfileInfoPage}
                      pageConfigItem={
                        userPortalPagesConfig.userPortalProfileInformation
                      }
                    />
                  ),
                },
                {
                  path: pagesConfig.viewAdmin.link,
                  element: (
                    <ProtectedRoute
                      component={ViewAdminLayout}
                      pageConfigItem={pagesConfig.viewAdmin}
                    />
                  ),
                  loader: () => viewAdminLoader(queryClient),
                  children: [
                    {
                      index: true,
                      element: (
                        <ProtectedRoute
                          component={MarketingManagerGridPage}
                          pageConfigItem={pagesConfig.marketingManager}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.marketingManager.link,
                      element: (
                        <ProtectedRoute
                          component={MarketingManagerGridPage}
                          pageConfigItem={pagesConfig.marketingManager}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.errorTesting.link,
                      element: (
                        <ProtectedRoute
                          component={ErrorTestingPage}
                          pageConfigItem={pagesConfig.errorTesting}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.adminLabs.link,
                      element: (
                        <ProtectedRoute
                          component={AdminLabsGridPage}
                          pageConfigItem={pagesConfig.adminLabs}
                        />
                      ),
                    },
                    {
                      path: pagesConfig.uiSandbox.link,
                      element: (
                        <ProtectedRoute
                          component={UiSandboxPage}
                          pageConfigItem={pagesConfig.uiSandbox}
                        />
                      ),
                    },
                  ],
                },
                {
                  path: userPortalPagesConfig.userPortalProfileInformation.link,
                  element: (
                    <ProtectedRoute
                      component={ProfileInfoPage}
                      pageConfigItem={
                        userPortalPagesConfig.userPortalProfileInformation
                      }
                    />
                  ),
                },
                {
                  path: userPortalPagesConfig.userPortalCustomAttributes.link,
                  element: (
                    <ProtectedRoute
                      component={CustomAttributesPage}
                      pageConfigItem={
                        userPortalPagesConfig.userPortalCustomAttributes
                      }
                    />
                  ),
                },
                {
                  path: userPortalPagesConfig.userPortalPersonalContacts.link,
                  element: (
                    <ProtectedRoute
                      component={UserContactsPage}
                      pageConfigItem={
                        userPortalPagesConfig.userPortalPersonalContacts
                      }
                    />
                  ),
                },
                {
                  path: userPortalPagesConfig.userPortalMyGroups.link,
                  element: (
                    <ProtectedRoute
                      component={MyGroupsPage}
                      pageConfigItem={userPortalPagesConfig.userPortalMyGroups}
                    />
                  ),
                  children: [
                    {
                      path: `${userPortalPagesConfig.userPortalGroupDetails.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={GroupDetailsPage}
                          pageConfigItem={
                            userPortalPagesConfig.userPortalGroupDetails
                          }
                        />
                      ),
                      children: [
                        {
                          index: true,
                          element: (
                            <ProtectedRoute
                              component={GroupGeneralInfo}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupGeneralInformation
                              }
                            />
                          ),
                        },
                        {
                          path: userPortalPagesConfig
                            .userPortalGroupGeneralInformation.link,
                          element: (
                            <ProtectedRoute
                              component={GroupGeneralInfo}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupGeneralInformation
                              }
                            />
                          ),
                        },
                        {
                          path: userPortalPagesConfig
                            .userPortalGroupBusinessGroupSettings.link,
                          element: (
                            <ProtectedRoute
                              component={BusinessGroupSettings}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupBusinessGroupSettings
                              }
                            />
                          ),
                        },
                        {
                          path: userPortalPagesConfig.userPortalGroupMembership
                            .link,
                          element: (
                            <ProtectedRoute
                              component={GroupMembership}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupMembership
                              }
                            />
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: `${userPortalPagesConfig.userPortalAllGroups.link}/*`,
                  element: (
                    <ProtectedRoute
                      component={AllGroupsPage}
                      pageConfigItem={userPortalPagesConfig.userPortalAllGroups}
                    />
                  ),
                  children: [
                    {
                      path: `${userPortalPagesConfig.userPortalGroupDetails.link}/*`,
                      element: (
                        <ProtectedRoute
                          component={GroupDetailsPage}
                          pageConfigItem={
                            userPortalPagesConfig.userPortalGroupDetails
                          }
                        />
                      ),
                      children: [
                        {
                          index: true,
                          element: (
                            <ProtectedRoute
                              component={GroupGeneralInfo}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupGeneralInformation
                              }
                            />
                          ),
                        },
                        {
                          path: userPortalPagesConfig
                            .userPortalGroupGeneralInformation.link,
                          element: (
                            <ProtectedRoute
                              component={GroupGeneralInfo}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupGeneralInformation
                              }
                            />
                          ),
                        },
                        {
                          path: userPortalPagesConfig
                            .userPortalGroupBusinessGroupSettings.link,
                          element: (
                            <ProtectedRoute
                              component={BusinessGroupSettings}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupBusinessGroupSettings
                              }
                            />
                          ),
                        },
                        {
                          path: userPortalPagesConfig.userPortalGroupMembership
                            .link,
                          element: (
                            <ProtectedRoute
                              component={GroupMembership}
                              pageConfigItem={
                                userPortalPagesConfig.userPortalGroupMembership
                              }
                            />
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: userPortalPagesConfig.userPortalSharedContacts.link,
                  element: (
                    <ProtectedRoute
                      component={SharedContactsUserPortalPage}
                      pageConfigItem={
                        userPortalPagesConfig.userPortalSharedContacts
                      }
                    />
                  ),
                },
                {
                  path: userPortalPagesConfig.userPortalDirectorySearch.link,
                  element: <DirectorySearchPage />,
                },
              ],
            },
            {
              path: '*',
              element: <NotFoundPage />,
            },
          ],
        },
      ],
    },
  ]);
}
